import * as C from "../../../i18n/constants.mjs";
import { registerCondition, getCondition } from "../conditionRegisterer.mjs";
import { CONDITION_NAME as CONDITION_CONTAINS } from "./contains.mjs";
export var CONDITION_NAME = 'not_contains';

/**
 * @param {object} dataRow The object which holds and describes the single cell value.
 * @param {Array} inputValues An array of values to compare with.
 * @returns {boolean}
 */
export function condition(dataRow, inputValues) {
  return !getCondition(CONDITION_CONTAINS, inputValues)(dataRow);
}
registerCondition(CONDITION_NAME, condition, {
  name: C.FILTERS_CONDITIONS_NOT_CONTAIN,
  inputsCount: 1,
  showOperators: true
});


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/filters/condition/notContains.mjs
// module id = 1398
// module chunks = 1